import { useAuth } from 'react-oidc-context';
import { useTranslation } from 'react-i18next';
import Link from '../components/Link';
import Sidebar, { NavItem } from '../components/Sidebar';
import { ACTIVE_CLASS, ENABLE_SYNC_UNIT_CONTROLLER } from '../constants/constants';
import ActiveLink from './ActiveLink';
import { env } from '../constants/env-config';

function LeftBar() {
  const auth = useAuth();
  const { t } = useTranslation();

  const handleLogout = () => {
    auth.removeUser();
    auth.signoutRedirect();
  };

  if (ENABLE_SYNC_UNIT_CONTROLLER) {
    // The shell of the mock: no background of its own (the shell is the grey --bg), a border to the content,
    // 230 px column from md and a top bar below it.
    return (
      <aside className="flex md:flex-col md:w-[230px] shrink-0 border-b md:border-b-0 md:border-r border-border">
        <div className="hidden md:flex items-center gap-2 px-6 pt-7 pb-8">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-accent-solid" aria-hidden="true">
            <path d="M4 17V7l8-4 8 4v10l-8 4-8-4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M4 7l8 4 8-4M12 11v10" stroke="currentColor" strokeWidth="1.6" />
          </svg>
          <span className="font-semibold tracking-tight text-[15px] text-text">OSA.tax</span>
        </div>
        <Sidebar />
        <div className="flex items-center gap-1 px-3 md:flex-col md:items-stretch md:mt-auto md:py-5">
          <div className="hidden md:flex items-center px-3 pb-3 text-sm">
            <span className="flex justify-center items-center font-medium rounded-full bg-accent-solid w-[30px] h-[30px] text-white">
              {auth.user?.profile.given_name.slice(0, 1)}
            </span>
            <p className="ml-2 leading-4 text-text font-medium">
              {auth.user?.profile.given_name}
              <br />
              {auth.user?.profile.family_name}
            </p>
          </div>
          {env.ENABLE_PROFILE === 'true' && (
            <NavItem to="/cabinet" icon="cabinet">
              {t('sidebar.leftBar.myCabinet')}
            </NavItem>
          )}
          <NavItem onClick={handleLogout} active={false}>
            {t('sidebar.leftBar.logout')}
          </NavItem>
        </div>
      </aside>
    );
  }

  return (
    <div className="hidden lg:flex bg-zinc-50 relative h-full bg-gray-25 flex-col lg:gap-4 w-[230px]">
      <div className="font-roboto font-medium text-2xl pl-8 pt-7 bg-clip-text text-transparent bg-gradient-to-r from-cyan-650 to-cyan-75">
        OSA.tax
      </div>
      {/* <div className="text-xs text-gray-350 ml-8 mt-3 w-[148px] rounded  p-2 bg-white">
        <p>
          Вітаємо вас в <br />
          особистому кабінеті
        </p>
      </div> */}

      <Sidebar />
      <div className="flex flex-1 items-end">
        <div className="py-6 flex-1">
          {/* <Link
            icon="setting"
            className="text-gray-350 text-sm block group pl-8 py-3"
            activeClassName={ACTIVE_CLASS}>
            Налаштування
            <ActiveLink />
          </Link> */}
          <div className="mt-6 mb-4 text-gray-350 text-sm inline-block flex items-center pl-4">
            <span
              className="flex justify-center items-center
                          font-medium rounded-full bg-gradient-to-r from-cyan-650 to-cyan-75 w-[30px] 
                          h-[30px] text-white"
            >
              {auth.user?.profile.given_name.slice(0, 1)}
            </span>
            <p className="ml-2 leading-4 text-black font-medium">
              {auth.user?.profile.given_name} 
              <br />
              {auth.user?.profile.family_name}
            </p>
          </div>
          {
            env.ENABLE_PROFILE === "true" && (
              <Link
                to="/cabinet"
                className="lg:mx-0 flex justify-center lg:justify-normal lg:flex-none lg:h-auto h-[60px] lg:pb-3 text-sm lg:w-auto lg:pl-7 lg:py-3 text-gray-350 group lg:pr-6 whitespace-nowrap"
                activeClassName={ACTIVE_CLASS}
                icon='profile'
                iconSize={20}
                iconClass="lg:mr-2 mr-0 w-[20px] h-[20px]"
              >
                <span className="hidden lg:inline-block">
                  {t('sidebar.leftBar.myCabinet')}
                </span>
                <ActiveLink />
              </Link>
            )
          }
        
          {/* <Link
            icon="profile"
            to="/profile"
            className="text-gray-350 text-sm pl-6 py-3 block hover:cursor-pointer whitespace-nowrap"
          >
            Мій кабінет
          </Link> */}
          <Link
            icon="logout"
            handleClick={handleLogout}
            className="lg:mx-0 flex justify-center lg:justify-normal lg:flex-none lg:h-auto h-[60px] lg:pb-3 text-sm lg:w-auto lg:pl-7 lg:py-3 text-gray-350 group lg:pr-6 whitespace-nowrap">
            {t('sidebar.leftBar.logout')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LeftBar;
